<!--声音克隆-->
<template>
  <div class="clone-box fs18 cr">
    <div class="flex ac jb mb30">
      <p class="bold" :style="{ color: theme.worksColor2 }">我的声音克隆<span v-if="myVoiceArray.length>0">·{{myVoiceArray.length}}</span>
      </p>
      <div class="flex ac">
        <div class="select-box fle mr30">
          <div class="flex ac jb">
            <div>
              <el-input
                placeholder="名称搜索"
                v-model="selectObj.name"
              >
                <el-button slot="append" icon="el-icon-search" @click="select()"></el-button>
              </el-input>
            </div>
            <div class="dz-btn-box cr" @click="handleAdd">+定制专属音频</div>
          </div>
        </div>
      </div>
    </div>
    <div class="no-fenshen-box" v-if="myVoiceArray.length<=0">
      <img src="../assets/pcImages/5.1_Icon_1@2x.png" alt="no">
      <p>上传一段音频, 快速复刻数字声音</p>
      <div class="ks-dingzhi cr" @click="handleAdd">+快速定制</div>
    </div>
    <div class="my-voice" v-if="show1">
      <div class="flex ac fw">
        <div class="clone-voice flex jb mr25 cr" @click="handleAdd" v-if="myVoiceArray.length>0"
             :style="{borderColor:theme.voiceColor1,backgroundColor: theme.voiceColor2}">
          <img src="https://xcyq.oss-cn-qingdao.aliyuncs.com/html/base/images/home/up3.svg" alt="">
          <div class="part1">
            <p :style="{color: theme.voiceColor3}">极速克隆您的专属声音</p>
            <p :style="{color: theme.voiceColor4}">上传音频自动克隆声音</p>
          </div>
          <div class="part2">
            <i class="el-icon-right"></i>
          </div>
        </div>
        <div class="every-voice flex ac" v-for="(item,index) in myVoiceArray" :key="index"
             :style="{borderColor:theme.voiceColor1,backgroundColor: theme.voiceColor2}">
          <!--          <div class="type1-tips" v-if="item.type==11">-->
          <!--            精品版-->
          <!--          </div>-->
          <!--          <div class="type2-tips" v-if="item.type==20">-->
          <!--            高保真-->
          <!--          </div>-->

          <div class="type1-tips"
               :style="{ background: item.api== 'fish' ? '#8336F4' : item.api== 'hs' ? '#8EB053' : item.api=='xf' ? '#2550F6': '#C58E34' }">
            {{item.voice_channel_name ? item.voice_channel_name : item.version_name}}
          </div>

          <div class="card-img" @mouseover="handleMouse(item)" @mouseleave="handleMouseOut" @click="handlePlay(item)">
            <img src="../assets/pcImages/1.3_Icon1@2x.png" alt="">
            <div class="hover-box icon-player playing" v-if="mouseState && hoverId==item.id">
              <div class="play-pause-btn">
                <i class="el-icon-video-play" v-if="palyState==1 || clickId!=item.id"
                   style="color: #ffffff;font-size: 25px"></i>
                <i class="el-icon-video-pause" v-if="palyState==2" style="color: #ffffff;font-size: 25px"></i>
                <img class="playing-box" v-if="palyState==3 && clickId==item.id"
                     src="../assets/pcImages/voice-playing.gif">
              </div>
            </div>
          </div>
          <div>
            <p class="pp4" :style="{color: theme.voiceColor3}">{{item.name}}</p>
            <p class="pp5" :style="{color: theme.voiceColor4}" v-if="item.generate_status==1">
              {{item.voice_channel_name ? item.voice_channel_name : item.version_name}}声音克隆中.....</p>
            <!--            <p class="pp5" v-else>高保真声音克隆 <span style="color: #89B5FB" v-if="item.train_status==2">(已确认)</span><span style="color: #89B5FB" v-if="item.train_status!=2&&item.remained_times>0">(未确认，可修改{{item.remained_times}}次)</span></p>-->
            <p class="pp5" v-else :style="{color: theme.voiceColor4}">{{item.voice_channel_name ? item.voice_channel_name : item.version_name}}声音克隆
              <span v-if="item.generate_status == 3" class="ml05 mr05" style="color: #F57241">失败</span>
              <span style="color: #89B5FB">{{item.remained_times>0 ? `(可修改${item.remained_times}次)`: '不可修改'}} </span>
            </p>
          </div>
          <div class="handle-box">
            <el-popover
              placement="top"
              width="120"
              v-model="item.visible">
              <div class="cr tc">
                <el-button type="primary" size="mini" style="margin-bottom: 5px" @click="handleReName(item)">重命名
                </el-button>
                <!--                <el-button type="primary" size="mini" style="margin-bottom: 5px" @click="handleEdit(item)">修改</el-button>-->
                <!--                <el-button type="primary" size="mini" style="margin-bottom: 5px" v-if="item.train_status!=2&&item.generate_status!=1&&item.api!='fy'" @click="handleSure(item)">确认声音</el-button>-->
                <el-button type="primary" size="mini" v-if="item.generate_status!=1&&item.remained_times>0"
                           style="margin-bottom: 5px" @click="handleEdit(item)">修改
                </el-button>
                <el-button type="warning" size="mini" v-if="item.remained_times==0" @click="handleDelete(item)">删除
                </el-button>
              </div>
              <template slot="reference">
                <div>
                  <i class="el-icon-more" :style="{color: theme.voiceColor4}"></i>
                </div>
              </template>
            </el-popover>
          </div>
        </div>
      </div>
    </div>


    <el-dialog
      title=""
      :visible.sync="dialogVisible1"
      :close-on-click-modal="false"
      width="30%"
    >
      <div class="dialog-box">
        <h1 class="tc">录制≥10秒，即刻克隆</h1>
        <h3>使用和付费提示</h3>
        <ul>
          <li>录制时的语气和情感也会被克隆，请按期望的音色效果进行朗读。</li>
          <li>我们建议您使用≥10秒的清晰语音音频，且不应包含任何混响、回声及背景噪音，以取得最佳效果。</li>
          <li>对于音频文件的质量，一般手机录音机是mp3格式都可以满足,文件大小不超过10M。</li>
          <li>离麦3-5厘米，1人人声，样本质量比长度更重要。有噪音的样本可能会产生不好 的结果，请尽可能提供高质量的样本语音。</li>
        </ul>
        <div class="clone-section">
          <h3>使用规范</h3>
          <div style="font-size: 14px;">您承诺所录制的音频为您本人所有或已获得合法授权，并遵守《本平台音色克隆功能使用规范》。为实现本功能，您需要朗读文案并录制音频。</div>
        </div>

        <div class="flex ac mt20">
          <el-checkbox v-model="checked">我已阅读并同意</el-checkbox>
          <span style="text-decoration:underline ;cursor: pointer" @click="goProtocol">《本平台音色克隆使用规范》</span>

        </div>
      </div>

      <span slot="footer" class="tc cr">
        <div class="submit-btn" @click="handleSumbit">我已知晓，同意</div>
      </span>
    </el-dialog>

    <el-dialog
      title="声音克隆"
      :visible.sync="dialogVisible2"
      width="50%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="">
        <p class="pp3"><span style="color: red">*</span> 声音名称</p>
        <el-input
          :disabled="nameDisabled"
          placeholder="请输入声音名称"
          v-model="voiceUpName">
        </el-input>
        <p class="pp3"><span style="color: red">*</span> 音频参数</p>
        <div class="voice-yq">
          <div class="pp2">音频要求</div>

          <ul class="ul-box">
            <li>文件格式：mp3、m4a、wav</li>
            <li>音频时长：{{upTip}}</li>
            <li>音频大小：小于20MB</li>
          </ul>
        </div>
        <p style="color: red;margin: 15px 0 0 0" v-if="remained_times>0">剩余修改次数:{{remained_times}}</p>
        <div class="upload-box mt20" v-if="fileList.length<=0">
          <el-upload
            ref="upload"
            drag
            :action="uploadUrl"
            accept=".mp3,.wav,.m4a,.MP3,.WAV,.M4A"
            :on-progress="handleUping"
            :on-success="handleFileUpSuccess"
            :on-error="handleFileUpError"
            :on-remove="handleRemove"
            :before-upload="beforeAvatarUpload"
            multiple
            :limit="1"
            :headers="myHeaders"
            :data="needParam"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">请上传一段音频，用于声音克隆</div>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          </el-upload>
        </div>
        <div class="upload-box mt20 flex ac jc" v-else>
          <audio
            ref="audioPlayer"
            :src="fileList[0].url"
            controls></audio>
          <el-button type="warning" size="mini" style="margin-left: 20px" @click="handleReUplod">重新上传</el-button>
        </div>

      </div>
      <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible2 = false">取 消</el-button>
    <el-button type="primary" @click="handleStartClone2">开始克隆</el-button>
  </span>
    </el-dialog>

    <el-dialog
      title="重命名"
      :visible.sync="dialogVisible3"
      width="25%"
      top="35vh"
    >
      <el-input v-model="name" placeholder="请输入名字"/>
      <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible3 = false">取 消</el-button>
    <el-button type="primary" @click="sumbitName2">确 定</el-button>
  </span>
    </el-dialog>

<!--    <el-dialog-->
<!--      :visible.sync="dialogVisible4"-->
<!--      title="选择音频训练模型"-->
<!--      width="58%"-->
<!--      top="30vh"-->
<!--    >-->
<!--      <div class="ai-choose-box flex ac jb">-->
<!--        <div class="ai-part2-box" v-for="(item,index) in voiceChannelList" :key="index" @click="goCreate(item.api)"-->
<!--             v-if="item.api!='xf'">-->
<!--          <div class="aipp1 bold">{{item.name}}克隆声音</div>-->
<!--          <div class="aipp2">{{item.desc}}</div>-->
<!--          <div class="aipp4 flex ac jc">-->
<!--            <img src="../assets/pcImages/Icon_Points@2x.png" alt="">-->
<!--            <div>{{item.credits>0?item.credits:'免费'}} <span v-if="item.credits>0">积分</span>-->
<!--              <span v-if="item.free_times>0">(剩余{{item.free_times}}次)</span>-->
<!--              <span v-if="item.free_times<=0 && item.credits<=0">无限克隆</span></div>-->
<!--          </div>-->
<!--          <div class="aibtn2">选择克隆语音包></div>-->
<!--          <div class="aipp5" v-if="item.train_times>0">-->
<!--            可修改{{item.train_times}}次-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </el-dialog>-->

    <el-dialog
      :visible.sync="dialogVisible4"
      top="30vh"
      custom-class="custom-dialog"
    >

      <div class="header-img">
        <img class="img1" src="https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcDarkImages/xinBan/2.0.0_dialog_Bg.png"
             alt="image">
        <img class="img2" @click.stop="dialogVisible4=false"
             src="https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcDarkImages/xinBan/2.2_Icon_Close.png"
             alt="image">
      </div>
      <div class="ai-choose-box flex ac jc">
        <div class="ai-part2-box tc" v-for="(item,index) in voiceChannelList" :key="index" @click="goCreate(item)"
             v-if="item.api!='xf'">

          <div class="aipp1 bold flex ac jc te">
            <img v-if="index === 0" src="https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcDarkImages/xinBan/2.0.0_Icon_1.png" alt="icon">
            <img v-if="(index + 1) % 2 === 0" src="https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcDarkImages/xinBan/2.0.0_Icon_2.png" alt="icon">
            <img v-if="(index + 1) % 3 === 0" src="https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcDarkImages/xinBan/2.0.0_Icon_3.png" alt="icon">
            <span class="te">{{item.name}}</span>
          </div>
          <div class="aipp2 te3 mb15">{{item.desc}}</div>
          <div class="aipp4 flex ac jc">
            <div>{{item.credits>0?item.credits:'免费'}} <span class="jf-text" v-if="item.credits>0">积分</span>
              <span class="jf-text" v-if="item.free_times>0">(剩余{{item.free_times}}次)</span>
              <span class="jf-text" v-if="item.free_times<=0 && item.credits<=0">无限克隆</span></div>
          </div>
          <div class="aibtn2">开始训练</div>
          <div class="aipp5" v-if="item.train_times>0">
            <span v-if="item.api=='mm'">确认后无法修改</span>
            <span v-else>可修改{{item.train_times}}次</span>
          </div>
        </div>
      </div>
    </el-dialog>


    <audio
      style="width: 1px;height: 1px;opacity: 0;position: fixed;right: 0;bottom: 0"
      ref="audioPlayer2"
      @ended="audioEnded"
      :src="audioSrc"
      controls></audio>
  </div>
</template>
<script>
  import {postVoice, getVoice, delVoice, voiceConfirm, uploadSign, uploadComplete, gvoiceChannel} from "../api/user";
  import {throttle} from "../../utils";

  export default {
    name: '',
    computed: {
      myHeaders() {
        return {'x-token': window.localStorage.getItem('xcToken') || ''}
      },
      theme() {
        return this.$store.getters.getTheme;
      }
    },
    data() {
      return {
        choosed: 1,
        name: '',
        dialogVisible1: false,
        checked: true,
        dialogVisible2: false,
        dialogVisible3: false,
        dialogVisible4: false,
        dialogVisible5: false,
        mouseState: false,
        palyState: 1,
        show1: true,
        show2: true,
        fileList: [],
        voiceUpName: '',
        loading: '',
        file_id: '',
        myVoiceArray: [],
        generate: 0,
        voiceArray: [],
        hoverId: '',
        clickId: false,
        audioSrc: '',
        myOneVoice: {},
        editId: '',
        remained_times: 0,
        selectObj: {
          source: '1', page: 1, limit: 9999, name: ''
        },
        needParam: {},
        uploadUrl: '',
        uploadDir: '',
        uploadSize: '',
        duration: 0,
        clone_usage: '',
        api: '',
        // 通道名字
        voice_channel_name: '',
        pollingInterval: null,
        nameDisabled: false,
        voiceChannelList: [],
        upTip: ''
      }
    },
    created() {
      if (window.localStorage.getItem('siteJson')) {
        const siteJson = JSON.parse(window.localStorage.getItem('siteJson'))
        this.clone_usage = siteJson.cloneUsage
      }
      this.choosed = this.$route.query.id || 1
      this.getVoiceList()
      this.getMyVoiceList()
      this.getUploadSign()
      this.getgvoiceChannel()
    },
    beforeDestroy() {
      if (this.pollingInterval) {
        clearInterval(this.pollingInterval);
      }
    },
    mounted() {
      // this.pollingInterval = setInterval(this.getMyVoiceList, 10000);
      // setTimeout(() => {
      //   if (this.generate > 0) {
      //     this.pollingInterval = setInterval(this.getMyVoiceList, 10000);
      //   }
      // }, 1500)
      // this.pollingInterval = setInterval(this.getMyVoiceList, 10000);
    },
    watch: {
      generate: {
        handler(newVal) {
          if (newVal > 0) {
            this.pollingInterval = setInterval(this.getMyVoiceList, 10000);
          }
        },
        immediate: true // 初始化时立即执行
      }
    },
    methods: {
      handleChoosed(val) {
        if (val == 2) {
          this.show1 = false
        } else if (val == 1) {
          this.show1 = true
          this.show2 = true
        }
        this.choosed = val
      },
      getVoiceList() {
        getVoice({source: '2', page: 1, limit: 9999}).then(res => {
          this.voiceArray = res.data.list
        })
      },
      select() {
        this.getMyVoiceList()
      },
      getMyVoiceList() {
        getVoice({...this.selectObj}).then(res => {
          this.myVoiceArray = res.data.list
          this.generate = res.data.generate
          if (res.data.generate <= 0) {
            if (this.pollingInterval) {
              clearInterval(this.pollingInterval);
            }
          }
        })
      },
      getUploadSign() {
        uploadSign({file_type: 'voice'}).then(res => {
          this.uploadUrl = res.data.host
          this.uploadDir = res.data.dir
          this.needParam = {
            'OSSAccessKeyId': res.data.access_key_id,
            'policy': res.data.policy,
            'signature': res.data.signature,
          }
        })
      },
      handleReName(item) {
        this.dialogVisible3 = true
        this.myOneVoice = item
      },
      handleAdd() {
        // this.dialogVisible1 = true
        // this.editId = ''
        // this.voiceUpName = ''
        // this.remained_times = ''
        this.editId = ''
        this.api = ''
        this.dialogVisible4 = true
        this.nameDisabled = false
        this.voiceUpName = ''
      },
      handleEdit(item) {
        if (item.api == 'xf') {
          this.$message.error('该渠道的声音，仅支持手持设备的录音修改！')
          return false
        }
        this.api = item.api
        this.fileList = []
        this.editId = item.id
        this.voiceUpName = item.name
        this.remained_times = item.remained_times
        if (item.type == 11) {
          this.nameDisabled = true
        } else {
          this.nameDisabled = false
        }
        this.dialogVisible2 = true
      },
      handleSure(item) {
        this.$confirm('此操作将确认生成该条声音，并且不可修改, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          voiceConfirm({voice_id: item.id}).then(() => {
            this.$message.success('确认成功')
            this.getMyVoiceList()
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消确认'
          })
        })
      },
      goCreate(item) {
        this.dialogVisible4 = false
        this.api = item.api
        this.voice_channel_name = item.version_name
        this.dialogVisible1 = true
        this.getOneTip(item.api)
      },

      handleDelete(item) {
        this.$confirm('此操作将永久删除该声音, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          delVoice({id: item.id}).then(res => {
            if (res) {
              this.$message.success('删除成功')
            }
            this.getMyVoiceList()
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      },

      sumbitName2: throttle(function () {
        this.sumbitName();
      }, 1000),

      sumbitName() {
        if (this.myOneVoice.id) {
          if (!this.name) {
            this.$message.error('请填写名称后保存')
          } else {
            postVoice({id: this.myOneVoice.id, name: this.name}).then(res => {
              this.$message.success('名称修改成功！')
              this.dialogVisible3 = false
              this.name = ''
              this.myOneVoice = {}
              this.getMyVoiceList()
            }).catch(error => {
              this.$message.error(error.msg)
            })
          }
        }
      },

      goProtocol() {
        const routeData = this.$router.resolve({
          path: '/protocol',
          query: {
            type: 'clone'
          }
        });
        window.open(routeData.href, '_blank');
      },

      handleSumbit() {
        if (this.checked) {
          this.dialogVisible1 = false
          this.dialogVisible2 = true
        } else {
          this.$message.error('请阅读并同意《本平台音色克隆使用规范》')
        }
      },

      handleStartClone2: throttle(function () {
        this.handleStartClone();
      }, 1000),

      handleStartClone() {
        if (!this.voiceUpName) {
          this.$message.error('请给您创建的声音起一个名称')
          return false
        } else if (!this.file_id) {
          this.$message.error('请上传音频')
          return false
        } else {
          if (this.editId) {
            postVoice({
              name: this.voiceUpName,
              file_id: this.fileList[0].file_id,
              id: this.editId,
              api: this.api,
              voice_channel_name: this.voice_channel_name
            }).then(() => {
              this.fileList = []
              // 重置上传组件
              // this.$refs.upload.clearFiles();
              this.voiceUpName = ''
              this.$message.success('上传成功')
              this.getMyVoiceList()
              this.loading.close();
            }).catch(error => {
              this.loading.close();
              this.$message.error(error.msg)
            })
          } else {
            postVoice({name: this.voiceUpName, file_id: this.fileList[0].file_id, api: this.api, voice_channel_name: this.voice_channel_name}).then(() => {
              this.fileList = []
              // 重置上传组件
              // this.$refs.upload.clearFiles();
              this.voiceUpName = ''
              this.$message.success('上传成功')
              this.getMyVoiceList()
              this.loading.close();
            }).catch(error => {
              this.loading.close();
              this.$message.error(error.msg)
            })
          }
          this.$store.dispatch('updatePoints')
          this.editId = ''
          this.dialogVisible2 = false
        }
      },
      handleMouse(item) {
        this.mouseState = true
        this.hoverId = item.id
      },
      handleMouseOut() {
        if (this.palyState != 3) {
          this.mouseState = false
        }
      },
      handlePlay(item) {
        this.mouseState = true
        this.clickId = item.id
        if (this.palyState == 1) {
          this.palyState = 3
          this.audioSrc = item.url
          this.$nextTick(() => {
            const audio = this.$refs.audioPlayer2
            audio.load()
            audio.play()
          })
        } else if (this.palyState == 3) {
          this.palyState = 1
          this.$refs.audioPlayer2.pause()
        }


        // if (this.hoverId != item.id) {
        //   this.hoverId = item.id
        //   this.audioSrc = item.url
        //   this.$nextTick(() => {
        //     const audio = this.$refs.audioPlayer
        //     audio.load()
        //     audio.play()
        //   })
        // } else {
        //   this.hoverId = null
        //   this.$refs.audioPlayer.pause()
        // }
      },
      audioEnded() {
        this.palyState = 1
      },

      handleReUplod() {
        this.fileList = []
        // 重置上传组件
        this.$refs.upload && this.$refs.upload.clearFiles();
        this.voiceUpName = ''
      },
      beforeAvatarUpload(file) {
        const that = this
        var file_type = file.name.split('.').slice(-1)
        var file_name = that.uploadDir + Date.parse(new Date()) + '' + parseInt(Math
          .random() * 100) + '.' + file_type
        that.needParam.key = file_name
        that.uploadSize = file.size

        const fileExtension = file.name.split('.').pop().toLowerCase()
        const url = URL.createObjectURL(file)
        const audio = new Audio(url)
        let result
        audio.muted = true
        audio.play().then(() => audio.pause())
        // return new Promise((resolve, reject) => {
        //   audio.addEventListener('loadedmetadata', function () {
        //     result = audio.duration // 获取音频时长
        //     if (result > 180 || result < 5) { // 假设我们限制音频时长不超过180秒
        //       that.$message.error('音频时长应在5秒~180秒之间')
        //       reject()
        //     } else {
        //       resolve()
        //     }
        //   })
        // })
        if (fileExtension == 'mp3' || fileExtension == 'm4a' || fileExtension == 'wav') {
          return true
        } else {
          that.$message.error('请上传MP3/M4A/WAV格式的音频')
          return false
        }
      },
      handleRemove() {
        this.fileList = []
      },
      handleUping() {
        this.loading = this.$loading({
          lock: true,
          text: '上传中,请等待...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.6)'
        });
      },
      handleFileUpSuccess(file) {
        // if (file.data.url && file.data.file_id) {
        //   this.fileList.push(file.data)
        //   this.$message.success('上传成功')
        //   this.loading.close();
        // }
        const url = `${this.uploadUrl}/${this.needParam.key}`
        // 获取时长
        const audio = new Audio(url);
        const that = this
        audio.addEventListener('loadedmetadata', () => {
          uploadComplete({file_type: 'voice', size: that.uploadSize, duration: audio.duration, url: url}).then(res => {
            if (res.data.url && res.data.file_id) {
              this.file_id = res.data.file_id
              this.fileList.push(res.data)
              this.$message.success('上传成功')
              this.loading.close();
              this.getMyVoiceList()
            }
          }).catch(() => {
            this.loading.close();
            this.fileList = []
            // 重置上传组件
            this.$refs.upload.clearFiles();
          })
        });
        audio.load();
      },
      handleFileUpError() {
        this.$message.error('上传失败，请重新上传')
        this.loading.close();
      },
      getgvoiceChannel() {
        gvoiceChannel().then(res => {
          this.voiceChannelList = []
          this.voiceChannelList = res.data
        })
      },
      // 根据api得出提示语
      getOneTip(val) {
        for (var i = 0; i < this.voiceChannelList.length; i++) {
          if (val == this.voiceChannelList[i].api) {
            this.upTip = this.voiceChannelList[i].upload_tips ? this.voiceChannelList[i].upload_tips :
              '建议3-5分钟'
            break
          }
        }
      },
    },
  }
</script>

<style lang="scss" scoped>
  .clone-box::-webkit-scrollbar {
    display: none !important;
    width: 0 !important;
    height: 0 !important;
  }
  .clone-box {
    box-shadow: 0 4px 12px 4px #0000000d;
    box-sizing: border-box;
    width: 100%;
    padding: 24px;
    height: calc(100vh - 50px);
    overflow-y: scroll;
    overflow-x: hidden;
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* Internet Explorer 10+ */

    p {
      margin: 0;
      padding: 0;
    }
  }


  .head-box {
    .choose-box {
      cursor: pointer;
      font-size: 18px;
      color: #7d87a1;
      line-height: 26px;
      font-weight: 500;
      height: 36px;
      margin-right: 30px;
    }

    .active {
      border-bottom: 2px solid #091221;
      color: #151b26;
    }
  }

  .dz-btn-box {
    width: 144px;
    height: 40px;
    background: #6C14FF;
    border-radius: 6px;

    font-weight: 500;
    font-size: 14px;
    color: #FFFFFF;
    line-height: 40px;
    text-align: center;
    margin-left: 15px;
  }


  .no-fenshen-box {
    margin-top: 40vh;

    img {
      width: 48px;
      height: 48px;
    }

    p {
      margin: 24px auto 28px;
    }

    font-weight: 400;
    font-size: 16px;
    color: #FAFAFA;
    text-align: center;

    .ks-dingzhi {
      width: 156px;
      height: 48px;
      background: linear-gradient(312deg, #6C14FF 0%, #01FBF5 100%);
      border-radius: 6px;

      font-weight: 600;
      font-size: 16px;
      color: #FFFFFF;
      line-height: 48px;
      text-align: center;
      margin: 0 auto;
    }
  }

  .my-voice {
    margin-top: 24px;

    .pp1 {
      font-size: 16px;
      line-height: 1;
      color: #091221;
      font-weight: 500;
      margin-bottom: 24px;

      span {
        font-size: 12px;
        margin-left: 8px;
        color: #888;
        letter-spacing: 1px;
      }
    }

    .clone-voice {
      margin-bottom: 25px;
      width: 392px;
      display: flex;
      padding: 8px;
      background: #24273C;
      /*border: 1px #e2e6ff dashed;*/
      border-radius: 6px;
      border: 1px solid;
      gap: 12px;
      height: 82px;

      img {
        width: 60px;
        height: 60px;
      }

      .part1 {
        width: 280px;
        padding-top: 10px;

        p:first-child {
          font-size: 14px;
          color: #000;
          line-height: 24px;
          font-weight: 500;
          margin-bottom: 5px;
        }

        p:last-child {
          font-size: 12px;
          color: #999;
        }
      }

      .part2 {
        width: 30px;
        padding-top: 40px;
      }
    }

    .every-voice {
      margin-right: 25px;
      margin-bottom: 25px;
      cursor: pointer;
      position: relative;
      width: 392px;
      display: flex;
      padding: 8px;
      /*background: #24273C;*/
      border: 1px solid;
      /*border: 1px solid #e2e6ff;*/
      border-radius: 6px;
      gap: 12px;
      height: 82px;

      .type1-tips, .type2-tips {
        position: absolute;
        right: 0;
        bottom: 0;
        min-width: 52px;
        height: 20px;
        background: #2550F6;
        border-radius: 4px;

        font-weight: 400;
        font-size: 12px;
        color: #FFFFFF;
        line-height: 20px;
        text-align: center;
      }

      .type2-tips {
        background: #7BBF00;
      }

      .card-img {
        position: relative;
        width: 44px;
        height: 44px;
        border-radius: 50%;
        margin-right: 16px;

        img {
          width: 100%;
          height: 100%;
          object-fit: fill;
          border-radius: 50%;
          /*border-radius: 8px;*/
        }

        .hover-box {
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
          border-radius: 50%;
          text-align: center;
          background: rgba(0, 0, 0, .5);
          cursor: pointer;
          justify-content: center;
          align-items: center;

          .play-pause-btn {
            margin-top: 10px;

            .playing-box {
              width: 30px;
              height: 18px;
            }
          }
        }
      }

      .pp4 {
        font-size: 14px;
        color: #fff;
        line-height: 24px;
        font-weight: 500;
        margin-bottom: 5px;
      }

      .pp5 {
        font-size: 12px;
        font-weight: 400;
        color: #aaaab5;
      }

      .all-tags {
        .every-tag {
          font-size: 12px;
          color: #5b647a;
          letter-spacing: 0;
          text-align: center;
          line-height: 20px;
          font-weight: 400;
          background: #edeef7;
          border-radius: 4px;
          padding: 0 4px;
          white-space: nowrap;
          margin-right: 5px;
        }
      }

      .handle-box {
        position: absolute;
        top: 3px;
        right: 10px;
      }
    }
  }


  .submit-btn {
    margin: 30px 0;
    background: #635cf6 !important;
    width: 100%;
    display: inline-block;
    vertical-align: middle;
    height: 38px;
    line-height: 38px;
    border: 1px solid transparent;
    padding: 0 18px;
    color: #fff;
    white-space: nowrap;
    text-align: center;
    font-size: 14px;
    border-radius: 2px;
    cursor: pointer;
  }

  .pp3 {
    font-size: 14px;
    color: #091221;
    line-height: 22px;
    font-weight: 500;
    margin: 15px 0 !important;
  }

  .voice-yq {
    background: #f3f4fb;
    padding: 16px;
    border-radius: 6px;

    .ul-box {
      line-height: 25px;
      display: grid;
      display: grid;
      grid-template-columns: repeat(3, 1fr);
    }

  }

  /*.ai-choose-box {*/
  /*  padding: 20px 0 40px;*/

  /*  .ai-part2-box, .ai-part3-box {*/
  /*    width: 330px;*/
  /*    height: 206px;*/
  /*    background: #FFFFFF;*/
  /*    border-radius: 8px;*/
  /*    border: 1px rgba(151, 151, 151, 0.5) dashed;*/
  /*    padding-top: 24px;*/
  /*    text-align: center;*/


  /*    .aipp2 {*/
  /*      background-size: 100% 100%;*/
  /*      font-weight: 400;*/
  /*      font-size: 12px;*/
  /*      color: #999999;*/
  /*      text-align: center;*/
  /*      margin: 12px 0 8px;*/
  /*    }*/


  /*    .aipp4 {*/
  /*      img {*/
  /*        width: 16px;*/
  /*        height: 16px;*/
  /*        margin-right: 4px;*/
  /*      }*/

  /*      font-weight: 400;*/
  /*      font-size: 12px;*/
  /*      color: #AA8242;*/
  /*      margin-bottom: 24px;*/
  /*    }*/

  /*    .aipp5 {*/
  /*      font-weight: 400;*/
  /*      font-size: 14px;*/
  /*      color: #C6702D;*/
  /*      text-align: center;*/
  /*      margin-top: 8px;*/
  /*    }*/

  /*    .aibtn1, .aibtn2, .aibtn3 {*/
  /*      width: 216px;*/
  /*      height: 36px;*/
  /*      background: #6C14FF;*/
  /*      border-radius: 4px;*/
  /*      font-weight: 500;*/
  /*      font-size: 14px;*/
  /*      color: #FFFFFF;*/
  /*      line-height: 36px;*/
  /*      text-align: center;*/
  /*      margin: 0 auto;*/
  /*    }*/

  /*    .aibtn2 {*/
  /*      background: #2551F0;*/
  /*      color: #FFFFFF;*/
  /*    }*/

  /*    .aibtn3 {*/
  /*      background: #7BBF00;*/
  /*      color: #FFFFFF;*/
  /*    }*/
  /*  }*/

  /*  .ai-part2-box:nth-child(1n) {*/
  /*    background: url("../assets/pcImages/2.0.0_bg2.png") no-repeat;*/
  /*    background-size: 100% 100%;*/
  /*  }*/

  /*  .ai-part2-box:nth-child(2n) {*/
  /*    background: url("../assets/pcImages/2.0.0_bg1.png") no-repeat;*/
  /*    background-size: 100% 100%;*/

  /*    .aibtn2 {*/
  /*      background-color: #84C80A;*/
  /*    }*/
  /*  }*/
  /*}*/
</style>
<style lang="scss">
  .clone-box .el-dialog__body {
    padding: 0 30px !important;
  }

  .upload-box .el-upload {
    width: 100%;
  }

  .upload-box .el-upload .el-upload-dragger {
    width: 100% !important;
  }

  .custom-dialog {
    width: 860px !important;
    padding: 0 !important;
    border-radius: 20px;

    .header-img {
      position: relative;

      .img1 {
        width: 100%;
        height: 110px;
      }

      .img2 {
        position: absolute;
        width: 32px;
        height: 32px;
        top: 0;
        right: 0;
        z-index: 9;
      }
    }

    .el-dialog__header {
      display: none;
    }

    .el-dialog__body {
      padding: 0 !important;
    }

    .ai-choose-box {
      width: 100%;
      padding: 20px 40px;

      .ai-part2-box {
        width: 220px;
        height: 248px;
        background: #F8F9FB;
        border-radius: 12px;
        border: 1px solid #EEEEEE;
        margin-right: 20px;
        position: relative;
      }
      .ai-part2-box:last-child{
        margin-right: 0;
      }
      .aipp1{
        font-weight: 600;
        font-size: 18px;
        color: #222222;
        text-align: center;
        width: 190px;
        margin: 35px auto 8px;
        img{
          width: 20px;
          height: 20px;
          margin-right: 4px;
        }
      }

      .aipp2 {
        width: 190px;
        height: 60px;
        font-weight: 400;
        font-size: 14px;
        color: #222222;
        line-height: 20px;
        text-align: center;
        margin: 0 auto 5px;
      }

      .aipp4 {
        font-weight: 500;
        font-size: 20px;
        color: #F4271F;
        line-height: 25px;
        text-align: center;
        margin-bottom: 24px;
        .jf-text{
          font-weight: 400;
          font-size: 12px;
          color: #222222;
        }
      }

      .aibtn2 {
        width: 180px;
        height: 36px;
        background: #6C14FF;
        border-radius: 8px;

        font-weight: 500;
        font-size: 14px;
        color: #FFFFFF;
        line-height: 36px;
        text-align: center;
        margin: 0 auto;
      }

      .aipp5{
        position: absolute;
        right: 0;
        top: 0;
        padding: 0 8px;
        height: 22px;
        background: #FFFFFF;
        border-radius: 6px;
        line-height: 22px;

        font-weight: 500;
        font-size: 12px;
        color: #42A0FA;
        text-align: center;
      }
    }

  }


</style>



// WEBPACK FOOTER //
// src/components/clone.vue